// Root layout for every B.1.5 route. Header + Sidebar are extracted
// from the legacy App.tsx so they persist across nested admin
// routes (/accounts/..., /audit, etc.) instead of only rendering
// for /fleet. AuthGate wraps the Outlet so an unauthenticated
// user sees the Keycloak sign-in card on every route.

import { lazy, Suspense } from "react";
import { createRootRoute, Outlet } from "@tanstack/react-router";

import { AuthGate } from "../auth/AuthGate";
import { SignOutButton } from "../auth/SignOutButton";
import { ServiceStatusBadge } from "../components/shell/ServiceStatusBadge";
import { Sidebar } from "../components/shell/Sidebar";

// Tree-shaken out of the prod bundle: import.meta.env.DEV is statically
// inlined by Vite, so the lazy() arm dead-codes in production.
const RouterDevtools = import.meta.env.DEV
  ? lazy(() =>
      import("@tanstack/router-devtools").then((m) => ({
        default: m.TanStackRouterDevtools,
      })),
    )
  : () => null;

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return (
    <AuthGate>
      <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
        <header
          style={{
            display: "flex",
            alignItems: "baseline",
            justifyContent: "space-between",
            gap: 16,
            padding: "20px 24px",
            borderBottom: "1px solid var(--border)",
          }}
        >
          <div>
            <h1 style={{ margin: 0, fontSize: "1.4rem", letterSpacing: "-0.01em" }}>
              Orixen Hub
            </h1>
            <p style={{ margin: "4px 0 0", color: "var(--text-dim)", fontSize: "0.85rem" }}>
              Operator console — health, clients, onboarding
            </p>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <ServiceStatusBadge />
            <SignOutButton />
          </div>
        </header>

        <div style={{ display: "flex", flex: 1, minHeight: 0 }}>
          <Sidebar />
          <main style={{ flex: 1, padding: "24px 32px", maxWidth: 1400, width: "100%" }}>
            <Outlet />
          </main>
        </div>

        <footer
          style={{
            padding: "12px 24px",
            borderTop: "1px solid var(--border)",
            color: "var(--text-dim)",
            fontSize: "0.75rem",
          }}
        >
          B.1.5 operator console — admin CRUD + audit viewer over the B.1 mutation API.
        </footer>
      </div>
      {import.meta.env.DEV && (
        <Suspense fallback={null}>
          <RouterDevtools position="bottom-right" />
        </Suspense>
      )}
    </AuthGate>
  );
}
